import React from 'react';
import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';

import { MailChangeForm } from 'components/setting/MailChangeForm';
import { BackButton } from 'components/common/buttons/BackButton';

import { withLogin } from 'pages/hocs/withLogin';

export const SettingMailPage: React.FC = withLogin(() => {
  return (
    <IonPage>
      <IonHeader mode="ios">
        <IonToolbar mode="ios">
          <IonButtons className="header">
            <BackButton defaultHref="/setting" />
          </IonButtons>
          <IonTitle>メールアドレスの変更</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <MailChangeForm />
      </IonContent>
    </IonPage>
  );
});
